import { ApiErrorResponse } from '../types';

/*
 * TODO: We want constants to be immutable and serializable.
 * We should separate this function into a logic file, and change this to an Enum
 * of handler names
 */
export const DEFAULT_HANDLERS = {
  noRetryFor400s: (failureCount: number, error: ApiErrorResponse) => {
    const status = error?.response?.status ?? -1;
    // Do not retry on 4xx errors
    if (status >= 400 && status < 500) {
      return false;
    }
    // Retry up to 3 times for other errors
    return failureCount < 3;
  },
};
